import React, { useState } from 'react';
import Config from '../shared/Config';
import useStatusApi, { normalizeStatusApiError } from './useStatusApi';

const { apiBaseUrl } = Config();
const endpointUrl = `${apiBaseUrl}/incidents/chartdata`;

const dateValueFormatter = (date) =>
  date.toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
  });

export default function useChartData() {
  const [loading, setLoading] = useState(true);
  /** @type {useState<any>} */
  const [chartData, setChartData] = useState();
  const [error, setError] = useState(null);
  const { ready, get } = useStatusApi();

  React.useEffect(() => {
    if (!ready) return undefined;
    let cancelled = false;
    setLoading(true);
    setError(null);

    get(endpointUrl)
      .then((response) => {
        if (cancelled) return;
        const data = {
          xAxis: [
            {
              id: 'dates',
              scaleType: 'time',
              valueFormatter: dateValueFormatter,
              data: response.data.map((item) => new Date(item.month)),
            },
          ],
          series: [
            {
              label: 'Uptime (% of estimated missed orders)',
              data: response.data.map((item) => Number(Number(item.uptime).toFixed(2))),
            },
          ],
        };
        setChartData(data);
        setLoading(false);
      })
      .catch((requestError) => {
        if (cancelled) return;
        setError(normalizeStatusApiError(requestError));
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [get, ready]);

  return { loading, chartData, error };
}
